import { useState } from 'react';
import { FormTab } from '../../../types/field-builder';

interface TabEditorProps {
  tab: FormTab;
  onSave: (tab: FormTab) => void;
  onClose: () => void;
}

export default function TabEditor({ tab, onSave, onClose }: TabEditorProps) {
  const [formData, setFormData] = useState<FormTab>(tab);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.label.trim()) {
      alert('O nome da aba é obrigatório');
      return;
    }

    onSave(formData);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900">
            {tab.label === 'Nova Aba' ? 'Nova Aba' : 'Editar Aba'}
          </h2>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg cursor-pointer"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Nome da Aba <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={formData.label}
              onChange={(e) => setFormData({ ...formData, label: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
              placeholder="Ex: Dados Básicos"
              required
              autoFocus
            />
            <p className="text-xs text-gray-500 mt-1">
              Este é o nome que aparecerá na aba do formulário
            </p>
          </div>

          <div className="flex items-center justify-end gap-3 pt-4 border-t border-gray-200">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 whitespace-nowrap cursor-pointer"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 whitespace-nowrap cursor-pointer"
            >
              Salvar Aba
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
